import Grid2 from '@mui/material/Unstable_Grid2';
import { TextField } from 'src/shared/components/Form/TextField';
import { Step } from '../../components/Step';
import { BoxWrapper, IconButtonWrapper } from './styles';
import HomeIcon from '@mui/icons-material/Home';
import LoginIcon from '@mui/icons-material/Login';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

type Step1Props = { handleGetUrl: () => void };

export const Step1 = ({ handleGetUrl }: Step1Props) => {
  const { values } = useFormState();
  const { t } = useTranslation('settings');

  return (
    <Step title={`${t('integrations.step')} 1`} subtitle={t('integrations.a3.connect your business')} Icon={HomeIcon}>
      <Grid2 xs={12} sx={{ paddingLeft: 0, paddingRight: 0 }}>
        <BoxWrapper>
          <TextField sx={{ width: '300px' }} label={t('integrations.company code')} name="companyCode" />
          <IconButtonWrapper onClick={handleGetUrl} disabled={!values.companyCode}>
            <LoginIcon />
          </IconButtonWrapper>
        </BoxWrapper>
      </Grid2>
    </Step>
  );
};
